<template>
    <div
        class="modal h-full"
        v-if="showProgramUserOptionsModal"
        aria-labelledby="edit-program-modal"
        role="dialog"
        aria-modal="true"
    >
        <div class="modal-overlay" aria-hidden="true"></div>
        <div
            class="inner shadow"
            style="-webkit-transform: translate3d(0, 0, 0)"
        >
            <a
                href="#"
                class="modal-close-btn"
                role="button"
                @click.prevent="closeModal()"
            >
                <i class="fal fa-times"></i>
            </a>
            <header
                class="modal-header items-start p-2 bg-white border-t-4 border-solid border-t-orange rounded-t-lg"
            ></header>

            <div class="modal-body items-start">
                <img
                    :src="`${cdnUrl}/${reward.program_image?.path}/_small/${reward.program_image?.file_name}`"
                    :alt="reward.name"
                    class="mb-8 mx-auto"
                    style="max-height: 100px; max-width: 175px"
                />

                <div
                    class="prose text-center mx-auto mb-3"
                    v-if="reward.connected"
                >
                    <p>
                        This program is connected to your
                        {{ reward.bank.name }} account.
                    </p>
                </div>

                <fieldset class="mb-5">
                    <legend class="text-base font-semibold leading-6">
                        Program Settings
                    </legend>
                    <p class="mt-1 text-sm leading-6 text-gray-600">
                        Choose below how you want to manage your
                        {{ reward.name }} balance.
                    </p>
                    <div class="mt-6 space-y-3">
                        <div
                            class="flex flex-col gap-y-3"
                            v-if="reward.institutions[reward.id].length > 1"
                        >
                            <div
                                class="flex items-center gap-x-3"
                                v-for="(bank, bIndex) in reward.institutions[
                                    reward.id
                                ]"
                                :key="'bank' + bIndex"
                            >
                                <input
                                    :id="'rewards-origin' + bIndex"
                                    name="rewards_source"
                                    type="radio"
                                    class="h-4 w-4 border-gray-300 form-radio"
                                    v-model="reward.program_user.rewards_source"
                                    :value="bank.institution_code"
                                    @click="setRewardsOrigin"
                                />
                                <label
                                    :for="'rewards-origin' + bIndex"
                                    class="block text-sm font-medium leading-6"
                                >
                                    <span v-if="bank">
                                        Automatically Sync via my
                                        {{ bank.name }} MX connection
                                    </span>
                                </label>
                            </div>
                        </div>
                        <div v-if="reward.institutions[reward.id].length === 1">
                            <div
                                class="flex items-center gap-x-3"
                                v-for="(bank, bIndex) in reward.institutions[
                                    reward.id
                                ]"
                                :key="'bank' + bIndex"
                            >
                                <input
                                    id="rewards-origin"
                                    name="rewards_source"
                                    type="radio"
                                    class="h-4 w-4 border-gray-300 form-radio"
                                    v-model="reward.program_user.rewards_source"
                                    value="mx"
                                    @click="setRewardsOrigin"
                                />
                                <label
                                    for="rewards-origin"
                                    class="block text-sm font-medium leading-6"
                                >
                                    <span v-if="bank">
                                        Automatically Sync via my
                                        {{ bank.name }} MX connection
                                    </span>
                                </label>
                            </div>
                        </div>
                        <div class="flex items-center gap-x-3">
                            <input
                                id="rewards-origin-1"
                                name="rewards_source"
                                type="radio"
                                class="h-4 w-4 border-gray-300 form-radio"
                                v-model="reward.program_user.rewards_source"
                                value="manual"
                                @click="setRewardsOrigin"
                            />
                            <label
                                for="rewards-origin-1"
                                class="block text-sm font-medium leading-6"
                            >
                                I'll Manage Them Manually
                            </label>
                        </div>
                    </div>
                </fieldset>
            </div>
            <div class="modal-message bg-white p-3" v-if="errors.length > 0">
                <Errors :errors="errors" />
            </div>
            <footer
                class="modal-footer flex-wrap justify-between items-center bg-gray-50"
            >
                <button
                    type="button"
                    class="btn btn-secondary !w-24 md:!w-48 !bg-gray-50"
                    @click.prevent="closeModal()"
                >
                    Close
                </button>
            </footer>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { usePointsStore } from '@/store/points';

import ActionButton from '@/components/action-button.vue';
import Errors from '@/components/errors.vue';

export default {
    components: {
        ActionButton,
        Errors,
    },
    data: () => ({
        errors: [],
    }),
    watch: {},
    computed: {
        ...mapState(usePointsStore, [
            'showProgramUserOptionsModal',
            'reward',
            'saveProgramBtnAction',
        ]),
        cdnUrl() {
            return window.cdnUrl;
        },
    },
    methods: {
        ...mapActions(usePointsStore, [
            'setShowProgramModal',
            'setRewardsOrigin',
        ]),
        saveProgramOptions() {},
        closeModal() {
            this.setShowProgramModal(false);
        },
    },
    created() {},
    mounted() {},
};
</script>
